import { produce } from "immer";
import {
  TOGGLE_ASSISTANT_MODE_SUCCESS,
  TOGGLE_THINKING_MODE_SUCCESS,
} from "../events/accountEvents";

const initialState = {
  assistantMode: false,
  thinkingMode: false,
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_ASSISTANT_MODE_SUCCESS: {
      return produce(state, (draft) => {
        draft.assistantMode = action.payload;
      });
    }
    case TOGGLE_THINKING_MODE_SUCCESS: {
      return produce(state, (draft) => {
        draft.thinkingMode = action.payload;
      });
    }

    default: {
      return state;
    }
  }
};

export default accountReducer;
